// @flow

import _ from 'lodash';

import type { Service, ServicesMap } from '@zapier/services/src/types';

const getServiceByKey = (
  services: ServicesMap | Service[],
  serviceKey: ?string
) => {
  return _.find(services, ({ key }) => key === serviceKey);
};

export default getServiceByKey;
